import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SMSInterface } from '@contracts/interfaces/sms.interface';
import { ConnectionService } from './connection.service';

@Injectable({
  providedIn: 'root'
})
export class SMSService {


    constructor(private http: HttpClient,
        private connectionService: ConnectionService ) {}

    sendSMS(options: SMSInterface) {
        
        return this.http.post(this.connectionService.address + "/sms-service/send-sms", options);
    }
}
